(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mmd-collection-cro"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-mmd-sort]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
